import { FC } from 'react'

const CameraIcon: FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.2168 1.5C7.568 1.5 7.89345 1.68426 8.0742 1.98535L8.46045 2.62842C8.50565 2.70372 8.587 2.75 8.6748 2.75H9.5C10.3285 2.75 11 3.42158 11 4.25V9C11 9.82845 10.3285 10.5 9.5 10.5H2.5C1.67158 10.5 1 9.82845 1 9V4.25C1 3.42158 1.67158 2.75 2.5 2.75H3.3252C3.41301 2.75 3.49437 2.70372 3.53955 2.62842L3.92578 1.98535C4.10653 1.68426 4.43201 1.5 4.78321 1.5H7.2168ZM6 4.25C4.75736 4.25 3.75 5.25735 3.75 6.5C3.75 7.74265 4.75736 8.75 6 8.75C7.24265 8.75 8.25 7.74265 8.25 6.5C8.25 5.25735 7.24265 4.25 6 4.25ZM6 5.25C6.69035 5.25 7.25 5.80965 7.25 6.5C7.25 7.19035 6.69035 7.75 6 7.75C5.30965 7.75 4.75 7.19035 4.75 6.5C4.75 5.80965 5.30965 5.25 6 5.25Z'
      fill='#717284'
    />
  </svg>
)

export default CameraIcon
